import { useEffect } from "react";
import { Layout } from "@/components/Layout";

export default function HowToPlay() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return <Layout>
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12" data-testid="how-to-play-page">
      <h1 className="font-display text-4xl sm:text-5xl mb-3">HOW TO PLAY</h1>
      <p className="text-muted-foreground italic text-base leading-relaxed mb-10">A few things you should know before you drop in.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <section className="border border-white/15 bg-card p-5">
          <h2 className="font-mono-caps text-xs text-primary mb-3">CHECK ANSWERS</h2>
          <p className="text-muted-foreground text-base leading-relaxed">You don't have to finish the entire puzzle to claim your score. When you're ready, hit <strong className="text-foreground">Check Answers</strong> to submit what you've got. Every correct answer counts!</p>
        </section>
        <section className="border border-white/15 bg-card p-5">
          <h2 className="font-mono-caps text-xs text-primary mb-3">SAVE YOUR PROGRESS</h2>
          <p className="text-muted-foreground text-base leading-relaxed">Life happens. Your puzzle progress is saved automatically, so you can leave and come back without starting over.</p>
        </section>
        <section className="border border-white/15 bg-card p-5">
          <h2 className="font-mono-caps text-xs text-primary mb-3">WORD STREAKS</h2>
          <p className="text-muted-foreground text-base leading-relaxed">Keep getting answers right to build your Word Streak. Get one wrong, and your streak resets. Hit 3, 5, and 10 consecutive correct answers for special celebrations.</p>
        </section>
        <section className="border border-white/15 bg-card p-5">
          <h2 className="font-mono-caps text-xs text-primary mb-3">NEED A HINT?</h2>
          <p className="text-muted-foreground text-base leading-relaxed">Stuck on a clue? Use your points to reveal a letter or a whole word. Premium members get letter hints and word reveals for free.</p>
        </section>
      </div>
    </div>
  </Layout>;
}
